import React, { useState } from "react";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";

const ImageUploader = () => {
  const [images, setImages] = useState([]);

  const handleImageUpload = event => {
    const files = Array.from(event.target.files);
    const imageUrls = files.map(file => URL.createObjectURL(file));
    setImages(prevImages => [...prevImages, ...imageUrls]);
  };

  const removeImage = index => {
    setImages(images.filter((_, i) => i !== index));
  };

  return (
    <div style={styles.container}>
      {/* Upload Box */}
      <label style={styles.uploadBox}>
        <input
          type='file'
          accept='image/*'
          multiple
          onChange={handleImageUpload}
          style={{ display: "none" }}
        />
        <div style={styles.uploadContent}>
          <CloudUploadOutlinedIcon />
          <p>Drop files here or click to upload</p>
        </div>
      </label>

      {/* Image Previews */}
      <div style={styles.previewContainer}>
        {images?.map((image, index) => (
          <div key={index} style={styles.imageWrapper}>
            <img src={image} alt={`preview-${index}`} style={styles.image} />
            <button onClick={() => removeImage(index)} style={styles.removeBtn}>
              ✖
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: "80%",
    margin: "20px auto",
    textAlign: "center",
  },
  uploadBox: {
    width: "100%",
    height: "200px",
    border: "2px dashed #ccc",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    background: "#f9f9f9",
  },
  uploadContent: {
    textAlign: "center",
    color: "#333",
  },
  uploadIcon: {
    marginBottom: "10px",
  },
  previewContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "20px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "100px",
    height: "100px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
    border: "1px solid #ddd",
  },
  removeBtn: {
    position: "absolute",
    top: "5px",
    right: "5px",
    background: "red",
    color: "white",
    border: "none",
    borderRadius: "50%",
    cursor: "pointer",
    width: "20px",
    height: "20px",
  },
};

export default ImageUploader;
